import React from 'react';
import './Arrow.scss';


const Arrow = () =>{
    return (
        <div class="arrow animated"></div>

    )
    
    }
    
    export default Arrow